import React, { useState, useRef } from 'react'
import { Spinner } from 'react-bootstrap'
import { pdfjs, Document, Page } from 'react-pdf'
import 'react-pdf/dist/esm/Page/AnnotationLayer.css'
import 'react-pdf/dist/esm/Page/TextLayer.css'

pdfjs.GlobalWorkerOptions.workerSrc = `//unpkg.com/pdfjs-dist@${pdfjs.version}/legacy/build/pdf.worker.min.js`

const options = {
  cMapUrl: 'cmaps/',
  standardFontDataUrl: 'standard_fonts/',
}

type pdfviewerprops = {
  url: string | File
  previewSettings: { isFluidWidth: boolean; width: number; height: number }
  type?: string
}

export default function PdfViewer({ url, previewSettings, type }: pdfviewerprops) {

  const [numPages, setNumPages] = useState<any>()
  const [scale, setScale] = useState(1)
  const [pageNumber, setPageNumber] = useState(1)
  const canvasRef = useRef<any>()
  function onDocumentLoadSuccess({ numPages: nextNumPages }: any) {
    setNumPages(nextNumPages)
  }
  const goToPrevPage = () => setPageNumber(pageNumber - 1 <= 1 ? 1 : pageNumber - 1)

  const goToNextPage = () => setPageNumber(pageNumber + 1 >= numPages ? numPages : pageNumber + 1)
  return (
    <div className='Example bg-white border-gray-400 border rounded'>
      <i
        className='bi bi-zoom-in text-muted cursor-pointer ms-2'
        onClick={() => setScale((prev) => scale + 1)}
      ></i>
      <span className='mx-2'>|</span>
      <i
        className='bi bi-zoom-out text-muted cursor-pointer'
        onClick={() => scale !== 1 && setScale(scale - 1)}
      ></i>
      <span className='mx-2'>|</span>
      <i className='bi bi-arrow-left text-muted cursor-pointer' onClick={() => goToPrevPage()}></i>
      <span className='mx-2'> {pageNumber} / {numPages || 0}</span>
      <i className='bi bi-arrow-right text-muted cursor-pointer' onClick={() => goToNextPage()}></i>
      <div className='Example__container'>
        <div
          className='Example__container__document'
          style={{ overflow: 'scroll', height: previewSettings.height }}
        >
          <Document
            file={type === 'contract' ? `${process.env.REACT_APP_IMAGE_BASE_URL}${url}` : url}
            loading={
              <div className='text-center'>
                <Spinner animation='border' className='text-gray-600 text-center' role='status'>
                  <span className='visually-hidden'>Loading...</span>
                </Spinner>
              </div>
            }
            onLoadSuccess={onDocumentLoadSuccess}
            onLoadError={(le) => console.log(le)}
            onError={(error) => console.log(error)}
            options={options}
          >
            <Page
              width={500}
              key={`page_${pageNumber + 1}`}
              canvasRef={canvasRef}
              pageNumber={pageNumber}
              scale={scale}
            />
          </Document>
        </div>
      </div>
    </div>
  )
}
